import React from "react";
import "./Education.css";

// --- 1. Import your university logo ---
import universityLogo from "../assets/McPherson_College_logo.png"; // Adjust the file name

function Education() {
  return (
    <section id="education" className="section bg-dark">
      <div className="container">
        <h2 className="section-title">Education</h2>
        <div className="education-list">
          {/* Card 1: University Degree with Logo */}
          <div className="education-card">
            <div className="education-icon-container">
              {/* --- 2. Replace the SVG with an img tag --- */}
              <img
                src={universityLogo}
                alt="University of Technology Logo"
                className="education-logo"
              />
            </div>
            <div className="education-info">
              <h3 className="education-title">
                Bachelor's of Science in Politics & History
              </h3>
              <h4 className="education-subtitle">
                Minor in Philosophy of Religion
              </h4>
              <p className="education-description">
                <strong>
                  <a
                    href="https://www.mcpherson.edu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="education-link"
                  >
                    McPherson College
                  </a>{" "}
                  - McPherson, KS
                </strong>{" "}
                (2016)
              </p>
              <div className="education-details">
                <ul>
                  <li>
                    Relevant Coursework: Introduction to Java, Data Structures,
                    Statistics, Biomedical Ethis, Evolution, American Diplomacy,
                    Peace Studies, Historiogrpahy, and more.
                  </li>
                  <li>
                    Member of{" "}
                    <a
                      href="https://www.phialphatheta.org/"
                      target="_blank"
                      className="education-link"
                      rel="noopener noreferrer"
                    >
                      Phi Alpha Theta
                    </a>{" "}
                    National History Honors Society
                  </li>
                  <li>
                    Senior Project:{" "}
                    <a
                      href="https://www.academia.edu/28962906/The_Marias_Massacre_of_Piegan_Indians_in_1870"
                      target="_blank"
                      className="education-link"
                      rel="noopener noreferrer"
                    >
                      The Marias Massacre of Piegan Indians in 1870
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Card 2: Certification (still using the SVG icon) */}
          <div className="education-card">
            <div className="education-icon-container">
              {/* This card can still use an SVG, showing the flexibility */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14.5 22H18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v11.5"></path>
                <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                <path d="M8 18h1.5a1.5 1.5 0 0 0 0-3H8v6Z"></path>
                <path d="M4.5 15H6v6"></path>
                <circle cx="6" cy="12" r="3"></circle>
              </svg>
            </div>
            <div className="education-info">
              <h3 className="education-title">
                Microsoft Programming in C# (20483)
              </h3>
              <p className="education-description">
                <strong>Microsoft</strong> (2017)
              </p>
              <div className="education-details">
                <ul>
                  <li>
                    20483: Programming in C# Training is developed to help
                    professionals gain the skills and knowledge needed to build
                    Windows applications with the help of C# language.
                  </li>
                  <li>
                    This technical course teaches the foundations of the C#
                    program structure, implementation details, and language
                    syntax.
                  </li>
                  <li>
                    It introduces the various technologies and techniques
                    employed by enterprise applications and modern desktops.
                  </li>
                  <li>
                    Throughout the course, students will learn to create
                    classes, implement, and define interfaces, and use generic
                    collections.
                  </li>
                  <li>
                    It helps in utilizing inheritance to build a class
                    hierarchy, create generic classes, and extend a .NET
                    Framework class.
                  </li>
                  <li>
                    From building a graphical user interface with XAML to
                    integrating unmanaged libraries into a C# application, this
                    course covers all the essential elements.
                  </li>
                </ul>
              </div>
              {/* Link to the program or course details */}
              {/*<div className="education-links">
                <a
                  href="https://www.udacity.com/course/react-nanodegree--nd019"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="education-link"
                >
                  View Program
                </a>
              </div>
              */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Education;
